import React from 'react';
import PropTypes from 'prop-types';
import { replaceCitations } from '@Utils/String';
import { ButtonWithIcon } from '@els/els-react--button';
import { LinkElement } from '@els/els-react--link-element';
import useEditInQueryBuilderButtonAttrs from '@Containers/ResultsPreview/hooks/useEditInQueryBuilderButtonAttrs';

function BlockFeedbacks({ previewItem, showStructurePopup = () => {}, copyQuery = () => {}, createAlert = () => {}, showFeedbacks }) {
  const editInQueryBuilderButtonAttrs = useEditInQueryBuilderButtonAttrs(previewItem);
  return (
    <div
      className="quick-results-preview__item_feedback feedback results-preview__block results-preview__block--feedbacks"
      id={previewItem.queryId}>
      {showFeedbacks && (
        <>
          {previewItem.feedbacks?.map((feedback) => {
            const title = replaceCitations(feedback.category);
            const capitalizedTitle = title.charAt(0).toUpperCase() + title.slice(1);

            return (
              <div className="feedback__item" key={`${feedback.category}_${feedback.value}`}>
                {feedback.structure && (
                  <div className="feedback__item_title">
                    <span className="feedback__item_title_label">{feedback.category}</span>
                    <span>:</span>
                    <ButtonWithIcon
                      data-e2e="structure-image-button"
                      type="secondary"
                      size="small"
                      sprite="Structure"
                      iconOnly
                      onClick={() => showStructurePopup(feedback.structure)}
                      className="u-els-margin-right-1o2 e2e-quick-results-query-structure"
                      aria-label="Click to view chemical structure in an expanded dialog">
                      Structure
                    </ButtonWithIcon>
                    <span className="feedback__item_title_value">{feedback.value}</span>
                  </div>
                )}

                {!feedback.structure && (
                  <div className="feedback__item_title">
                    <span className="feedback__item_title_label">{capitalizedTitle}</span>
                    <span>:</span>
                    <span className="feedback__item_title_value">{feedback.value}</span>
                  </div>
                )}
              </div>
            );
          })}
          {previewItem.fullyLoaded && (
            <div className="feedback__buttons">
              <ButtonWithIcon
                type="link"
                sprite="Alarm"
                iconRight
                linkIconSize="xs"
                data-e2e="e2e-create-alert-button"
                onClick={() => {
                  createAlert(previewItem);
                }}
                className="rx-no-wrap e2e-create-alert u-els-margin-right-1o2">
                Create Alert
              </ButtonWithIcon>
              <LinkElement
                href="#"
                iconSprite="Note"
                iconSize="xs"
                iconRight
                data-e2e="e2e-edit-in-query-builder-button"
                onClick={(event) => {
                  event.preventDefault();
                  copyQuery(previewItem);
                }}
                className={`e2e-edit-qb rx-no-wrap ${editInQueryBuilderButtonAttrs?.className}`}
                aria-label="Edit in Query Builder">
                {editInQueryBuilderButtonAttrs?.label || 'Edit'}
              </LinkElement>
            </div>
          )}
        </>
      )}
    </div>
  );
}

BlockFeedbacks.propTypes = {
  previewItem: PropTypes.object.isRequired,
  showStructurePopup: PropTypes.func,
  copyQuery: PropTypes.func,
  createAlert: PropTypes.func,
  showFeedbacks: PropTypes.bool,
};

export default BlockFeedbacks;
